export default "__VITE_ASSET__Ct_tmuMc__"